import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, a = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M7.735 2.679a2.51 2.51 0 0 1 1.007-.21h6.366A2.528 2.528 0 0 1 17.5 4.183c.112.331.154.682.123 1.03l-.001.02-.29 4.728h-10.9l-.207-4.772v-.02a2.518 2.518 0 0 1 1.51-2.49ZM6.493 11.36h10.753l-.319 5.211a2.52 2.52 0 0 1-2.514 2.288H9.235a2.527 2.527 0 0 1-2.517-2.332l-.225-5.167Zm2.25-10.292a3.928 3.928 0 0 0-3.701 2.616 3.918 3.918 0 0 0-.215 1.574l.492 11.34.001.02a3.92 3.92 0 0 0 3.915 3.642h1.989v1.944a.7.7 0 1 0 1.4 0V20.26h1.79a3.926 3.926 0 0 0 3.908-3.573l.002-.02.694-11.34a3.918 3.918 0 0 0-2.328-3.926 3.928 3.928 0 0 0-1.582-.333H8.742Zm2.466 14.818a.713.713 0 1 1 1.427.001.713.713 0 0 1-1.427-.001Zm.715-2.113A2.113 2.113 0 1 0 11.922 18a2.113 2.113 0 0 0 .002-4.227Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  a
];
function r(c, d) {
  return e(), t("svg", o, [...n]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
